<template>
    <div
        class="BaseTag"
        :class="classes"
    >
        {{ title }}
    </div>
</template>
<script>
export default {
    name: 'BaseTag',
    props: {
        title: {
            type: String,
            required: true
        },
        classes: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
    .BaseTag {
        display: flex;
        align-items: center;
        margin-bottom: getSpacing('small');
        padding: 0.5em 0.75em;
        background-color: getColour('lightblue', 'dark');
        line-height: 1em;
        border-radius: 50px;
        color: getColor('white');
        font-weight: 600;
        font-size: 12px;
    }

    .BaseTag--ghost {
        background: transparent;
        border: 2px solid rgba(getColor('white'), 0.5);
    }

    .BaseTag--squared {
        background: getColour('blue', 'base');
        border-radius: 0;
    }
</style>
